const Provinces = 
 [
  "Córdoba", 
  "Buenos Aires", 
  "Catamarca", 
  "Chaco", 
  "Chubut", 
  "Corrientes", 
  "Entre Ríos", 
  "Formosa", 
  "Jujuy", 
  "La Pampa", 
  "La Rioja", 
  "Mendoza", 
  "Misiones", 
  "Neuquén", 
  "Rio Negro", 
  "Salta", 
  "San Juan", 
  "San Luis", 
  "Santa Cruz", 
  "Santa Fe", 
  "Santiago del Estero", 
  "Tierra del Fuego", 
  "Tucumán"
]

export default Provinces


// WEBPACK FOOTER //
// ./src/common/Provinces.js